import { createFileRoute } from '@tanstack/react-router';
import { useActiveCompanyId } from '../../stores/useCompanyStore';
import {
  useClasses,
  useCreateClass,
  useUpdateClass,
  useDeactivateClass,
} from '../../hooks/useDimensions';
import { DimensionPage } from '../../components/dimensions/DimensionPage';

export const Route = createFileRoute('/_auth/classes')({
  component: ClassesPage,
});

function ClassesPage() {
  const companyId = useActiveCompanyId();
  return (
    <DimensionPage
      companyId={companyId}
      title="Classes"
      singular="class"
      hideInactiveKey="accounting:classes:hideInactive"
      hooks={{
        useList: useClasses,
        useCreate: useCreateClass,
        useUpdate: useUpdateClass,
        useDeactivate: useDeactivateClass,
      }}
    />
  );
}
